import React, { useState } from 'react'
import { Button, Grid, Image, Segment } from 'semantic-ui-react'
import internal from '../../../../assets/svg/internal_project_big.svg'
import internal_selected from '../../../../assets/svg/internal_project_big_selected.svg'
import internal_small from '../../../../assets/svg/internal_project_small.svg'
import internal_selected_small from '../../../../assets/svg/internal_project_small_selected.svg'
import select_icon from '../../../../assets/svg/modal_select_icon.svg'
import service from '../../../../assets/svg/service_provider_project.svg'
import service_selected from '../../../../assets/svg/service_provider_project_selected.svg'
import sponsor from '../../../../assets/svg/sponsor_project.svg'
import sponsor_selected from '../../../../assets/svg/sponsor_project_selected.svg'
import WizardComponent from '../../../../components/Modal/WizardComponent'
import { IUserDetail } from '../../../../types/user'
import { checkRole } from '../../../../utils/checkRole'
import { IWizardProject } from '../../types/wizardData'

interface Props {
  open: boolean
  data: IWizardProject
  wizardFinishedSteps: number[]
  user: IUserDetail | null
  setWizardFinishedSteps: (steps: number[]) => void
  setWizardStep: (step: string) => void
  setProjectWizardData: (data: IWizardProject) => void
  onClose: () => void
}

const projectTypes = [
  { id: 1, rights: [7], type: 'sponsor', name: 'Sponsor', image: sponsor, image_selected: sponsor_selected, description: 'Include all funding sources and keep track on the state of expenditures of internal teams and external subcontractor costs.' },
  { id: 2, rights: [9], type: 'service_provider', name: 'Service Provider', image: service, image_selected: service_selected, description: 'Deliver profitable projects through a holistic view on progress and margin, invoicing status and reached milestones.' },
  { id: 3, rights: [8], type: 'internal', name: 'Internal', image: internal, image_selected: internal_selected, description: 'Track the time and budget spent on meetings, adminstration tasks or personal training and organisational development projects.' }
]

const WizardChooseProjectType = (props: Props): JSX.Element => {
  const { user } = props
  const [projectType, setProjectType] = useState<string>(props.data.type)

  const onClick = (type: string) => {
    setProjectType(type)
  }

  const handleBudgetImportClick = () => {
    const _data: IWizardProject = {
      ...props.data,
      type: 'budget_import',
      health: 'on_track'
    }
    if (!props.wizardFinishedSteps.includes(2)) {
      props.setWizardFinishedSteps([1, 2])
    }
    props.setWizardStep('budget-selection')
    props.setProjectWizardData(_data)
  }

  const canSeeBudgetImport = (): boolean => {
    return user !== null && (checkRole(user, [7]) || checkRole(user, [9]))
  }

  const renderContent = () => {
    return (
      <Grid>
        <Grid.Row columns={3}>
          {projectTypes.map(pt => {
            if (user && checkRole(user, pt.rights)) {
              return (
                <Grid.Column key={pt.id}>
                  <Segment
                    onClick={() => onClick(pt.type)}
                    style={{
                      cursor: 'pointer',
                      borderRadius: '4.8px',
                      height: '237px',
                      opacity: pt.type === projectType || projectType === '' ? 1 : .6,
                      border: `1px solid ${pt.type === projectType ? '#08D6A1' : '#E5EBF0'}`,
                      backgroundColor: pt.type === projectType ? '#FFF' : 'transparent',
                      width: '202px',
                      boxShadow: pt.type === projectType ? '0px 0px 25px -5px rgba(21, 21, 21, 0.10)' : '',
                      marginRight: '20px',
                      padding: '17px'
                    }}>
                    {pt.type === projectType && <Image circular style={{ float: 'right' }} src={select_icon} />}
                    {pt.type === 'internal' ?
                      <div style={{ display: 'flex', width: '40px', height: '27px', alignItems: 'flex-end', justifyContent: 'space-between', margin: '20px auto 17px' }}>
                        <Image style={{ opacity: pt.type === projectType || projectType === '' ? 1 : .6 }} src={pt.type === projectType ? pt.image_selected : pt.image} />
                        <Image style={{ opacity: pt.type === projectType || projectType === '' ? 1 : .6 }} src={pt.type === projectType ? internal_selected_small : internal_small} />
                      </div> :
                      <Image style={{ margin: '20px auto 17px', opacity: pt.type === projectType || projectType === '' ? 1 : .6 }} src={pt.type === projectType ? pt.image_selected : pt.image} />}
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'baseline' }}>
                      <p style={{ margin: 0, fontSize: '16px', letterSpacing: '.22px', fontWeight: 'bold', color: pt.type === projectType ? '#172533' : '#747678', paddingBottom: '8px' }}>{pt.name}</p>
                    </div>
                    <p style={{ fontSize: '11px', fontWeight: 'bold', letterSpacing: '.25px', color: pt.type === projectType ? '#172533' : '#747678', textAlign: 'center' }}>{pt.description}</p>
                  </Segment>
                </Grid.Column>
              )
            }
            return null
          })}
        </Grid.Row>
        {canSeeBudgetImport() && (
          <Grid.Row style={{ padding: 0 }}>
            <Grid.Column style={{ padding: 0 }}>
              <div
                onClick={handleBudgetImportClick}
                style={{
                  cursor: 'pointer',
                  color: 'rgba(8, 214, 161, 1)',
                  fontSize: '14px',
                  fontWeight: 500,
                  textAlign: 'left',
                  marginTop: '8px',
                  marginBottom: 0,
                  paddingTop: 0,
                  paddingBottom: 0,
                  paddingLeft: '16px',
                  paddingRight: '16px'
                }}
              >
                Import from Study Budgeting →
              </div>
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    )
  }

  const renderFooter = () => {
    return (
      <Button
        primary={true}
        size='small'
        onClick={goToNextStep}
        content='Next'
        disabled={projectType === ''}
        style={{ width: '8.57rem', height: '2.14rem', borderRadius: '.34rem', padding: 0, margin: 0 }}
      />
    )
  }

  const goToNextStep = () => {
    const _data: IWizardProject = {
      ...props.data,
      type: projectType,
      health: 'on_track'
    }
    if (!props.wizardFinishedSteps.includes(2)) {
      props.setWizardFinishedSteps([1, 2])
    }
    const nextStep = projectType === 'budget_import' ? 'budget-selection' : 'step-two'
    props.setWizardStep(nextStep)
    props.setProjectWizardData(_data)
  }

  const renderWizard = () => {
    const _data: IWizardProject = {
      ...props.data,
      type: projectType,
      health: 'on_track'
    }
    const _steps = [
      { key: 1, name: 'step-one' },
      { key: 2, name: 'step-two' },
      { key: 3, name: 'step-three' },
      { key: 4, name: 'step-four' },
      { key: 5, name: 'step-five' },
      { key: 6, name: 'step-six' }
    ]
    return (
      <WizardComponent
        open={props.open}
        close={props.onClose}
        content={renderContent()}
        headerContent='Choose Project Type'
        headerColor='#232C58'
        footer={renderFooter()}
        steps={props.data.type === 'service_provider' ? 6 : 5}
        activeStep={1}
        width={'756px'}
        finishedSteps={props.wizardFinishedSteps}
        setWizardStep={props.setWizardStep}
        setProjectWizardData={props.setProjectWizardData}
        data={_data}
        stepStringList={_steps}
        contentPadding='0 48px 2rem'
        actionPadding='20px 48px'
      />
    )
  }

  return renderWizard()
}

export default WizardChooseProjectType
